import cn from "classnames"

import { SearchPageLink } from "app/AppRouter/links/SearchPageLink"
import { Img } from "ui-kit/components-branded/index"
import style from "modules/SelectionOfPsychologists/components/NobodyLikedCard/style.module.scss"

interface NobodyLikedCardProps {
    headline: JSX.Element | string
    secondary: JSX.Element | string
}

export function NobodyLikedCard({ headline, secondary }: NobodyLikedCardProps) {
    return (
        <section className={style.container}>
            <div>
                <div className={style.title}>{headline}</div>
                <div>{secondary}</div>
            </div>

            <div className={style.content}>
                <Img
                    className={style.image}
                    src="select-therapist-illustration-first.svg"
                    alt="Клиент успешно отправил заявку"
                    width={296}
                    height={168}
                />
                <SearchPageLink
                    className={cn(
                        style.button,
                        "border-radius-5 py-3 px-5 text-center b-button button--regular w-100 transition-ease"
                    )}
                >
                    Перейти в каталог
                </SearchPageLink>
            </div>
        </section>
    )
}
